function tbe_fix_product_details()
{
	var product_item_details_height = 79; // default height
	var padding_default = 9;

	$('.product-item__details').each(function(){

		if( $(this).outerHeight() > product_item_details_height ){
			product_item_details_height = $(this).outerHeight();
		}
	});

	$('.product-item__details').each(function(){

		if( $(this).outerHeight() < product_item_details_height ){

			var new_padding = ( (product_item_details_height - $(this).outerHeight()) / 2 ) + padding_default;
			$(this).css('padding-top', new_padding);
			$(this).css('padding-bottom', new_padding);
		}
	});
}


jQuery(document).ready(function($){

	/**
		FEATURED PRODUCTS SLIDER
	**/

	var owl_slider = $('#shopify-section-featured-products .collection__list').addClass('owl-carousel').owlCarousel({
		items: 4,
		margin: 25,
		nav: true,
		loop: true,
		navText:[
			'<svg class="icon icon-arrow-left"><use xlink:href="#icon-arrow-left"></use></svg>',
			'<svg class="icon icon-arrow-right"><use xlink:href="#icon-arrow-right"></use></svg>'
		],
		responsive:{
			0:{
				items: 1,
				margin: 0
			},
			500:{
				items: 4
			}
		}
	});

	/**
		MOBILE MENU
	**/
	$('.tbe-mobile-nav-icon').on('click', function(){
		$('.tbe-mobile-overlay').fadeIn('400');
	});
	$('.tbe-mobile-overlay-close').on('click', function(){
		$('.tbe-mobile-overlay').fadeOut('400');
	});

	$('.tbe-has-dropdown > a').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();

		$('.tbe-mobile-overlay').addClass('tbe-submenu-active');

		return false;
	});

	$('.tbe-mobile-overlay-back').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();

		$('.tbe-mobile-overlay').removeClass('tbe-submenu-active');

		return false;
	});


	// design thrash
	/*var pages = [
		'.template-collection',
		'.template-product'
	];

	for (var i = pages.length - 1; i >= 0; i--) {
		$(pages[i] + ' .header .header__push').before('<div class="tbe-page-title"><span>'+ $('.header__push-title').text() +'</span></div>');
		$(pages[i] + ' .header .header__logo-image').attr('srcset', '');
		$(pages[i] + ' .header .header__logo-image').attr('src', '//cdn.shopify.com/s/files/1/0333/3695/0829/files/breadessentials-logo_150x.png?v=1581790890');
	}*/

	// change vendor to breadcrumbs on product page
	//var breadcrumb = $('.template-product .breadcrumb').clone();
	//$('.template-product .product__vendor').html( breadcrumb );

	// change vendor to product category
	//$('.template-product .product__vendor a').text('Bread'); // bread, flatbead, ...

});


/*function appendStyle(styles) {
  var css = document.createElement('style');
  css.type = 'text/css';

  if (css.styleSheet) css.styleSheet.cssText = styles;
  else css.appendChild(document.createTextNode(styles));

  document.getElementsByTagName("head")[0].appendChild(css);
}*/

//var styles = 'div[data-alternative-payments] { display:none!important; }';
//appendStyle(styles);